export const STATUS_BACKGROUND_COLORS: Record<string, string> = {

  'Assigned': '#629DFF',
  'Pending': '#FFE9D4',
  'In Progress': '#FCEFC6',
  'Complete': '#A7E5B1',
  'Canceled': '#FFDFDF',
  'Review': '#E7D9FF',
  'on Hold': '#FFFCD7',
  'Quote': '#D0F0FF',
  'Declined': '#F4B4B4',
  'MX Exception': '#E88787',
  'Exception': '#F2A7D4',
  'Delivered': '#4FE868',
  'Cancelled': '#e3adb2',
  'Submitted to MX': '#B1F6AD',
  
};

export const STATUS_MAP: Record<string, string> = {
    green: 'Green Check.png',
    red: 'Red Check.png',
    orange: 'Orange Check.png',
    grey: 'Grey Check.png',
};

export const STATUS_STROKE: Record<string, string> = {
  
  'Assigned': '#CFE1FF',
  'Pending': '#f7d668',
  'In Progress': '#f7d668',
  'Complete': '#4cc15f',
  'Canceled': '#e67373',
  'Review': '#A571FF',
  'on Hold': '#F8D7A0',
  'Quote': '#41C2FF',
  'Declined': '#FF3232',
  'MX Exception': '#930000',
  'Exception': '#C8077B',
  'Delivered': '#0A861E',
  'Cancelled': '#d76666',
  'Submitted to MX': '#20B220',

};